import LegalTenancyPage from './LegalTenancyPage';

const Privacy = () => {
  return <LegalTenancyPage isTermsActive={false} contentGroup="privacy" />;
};

export { Privacy };
